import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import { Button, Card } from "react-bootstrap";

function MedPage() {
    return (<>
        <Navbar />
        <Card>
            <Card.Header>Tauchmedizin & Gesundheit</Card.Header>
            <Card.Body>
                <Card.Text>
                    Für eine Tauchausbildung in unserem Verein ist eine ärztliche Tauglichkeitsbescheinigung nach den Richtlinien des VDST erforderlich.
                    <br /><br />
                    Wir empfehlen dir die Tauchtauglichkeitsuntersuchung (TTU) bei einem Taucherarzt machen zu lassen.
                    Für das Schwimmhallentraining ist keine TTU erforderlich. Wir empfehlen aber eine Untersuchung beim Kinder-/Hausarzt in Bezug auf das Flossenschwimmen und Streckentauchen (Wassertiefe 1,8 m).
                    <br /><br />
                    Folgende Links dienen nur als Empfehlung und nicht als Werbung. Wir können hier mit ruhigem Gewissen sagen, dass du dort in guten Händen bist und stehen selbst in Kontakt mit den jeweiligen Ärzten.
                    <br /><br />
                    <strong>Empfohlene Anlaufstellen:</strong>
                    <ul>
                        <li><a href="https://www.tauchen-medizin.de" target="_blank" rel="noopener noreferrer">Tauchmedizin Reinhold & Hübner</a></li>
                        <li><a href="https://www.vivantes.de/klinikum-im-friedrichshain/zentrum-sauerstofftherapie-tauchmedizin" target="_blank" rel="noopener noreferrer">Zentrum für Sauerstofftherapie und Tauchmedizin in Berlin Friedrichshain</a></li>
                        <li><a href="https://www.gtuem.org/tauchtauglichkeit/sh-20.html" target="_blank" rel="noopener noreferrer">Weitere Infos und Tauchmediziner</a></li>
                    </ul>
                    <br />
                    <strong>Notfallkontakt:</strong><br />
                    Taucher - Hotline <a href="tel:+49 69 800 88 616">+49 69 800 88 616</a> / 24 Stunden hilfsbereit (Notfallhilfe des VDST)
                </Card.Text>
            </Card.Body>
        </Card>

        <Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
    </>);
}

export default MedPage;
